export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_szerelomuhely/artifacts/63qi0n58_autoesgumi.png";

export const BRAND = {
  name: "Ady Autó- és Gumiszerviz",
  short: "Ady Szerviz",
  address: "1221 Budapest, Ady Endre út 115.",
  phoneDisplay: "(06 1) 226 3974",
  phoneTel: "tel:+3612263974",
  mapEmbed:
    "https://www.google.com/maps?q=1221%20Budapest%2C%20Ady%20Endre%20%C3%BAt%20115&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=1221%20Budapest%2C%20Ady%20Endre%20%C3%BAt%20115",
};

export const OPENING_HOURS = [
  { day: "Hétfő", hours: "8:00 – 16:30", dow: 1 },
  { day: "Kedd", hours: "8:00 – 16:30", dow: 2 },
  { day: "Szerda", hours: "8:00 – 16:30", dow: 3 },
  { day: "Csütörtök", hours: "8:00 – 16:30", dow: 4 },
  { day: "Péntek", hours: "8:00 – 16:00", dow: 5 },
  { day: "Szombat", hours: "Zárva", dow: 6, closed: true },
  { day: "Vasárnap", hours: "Zárva", dow: 0, closed: true },
];

export const REAL_PHOTOS = {
  shop:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_szerelomuhely/artifacts/uewtwjy9_Ke%CC%81pernyo%CC%8Bfoto%CC%81%202026-09-03%20-%2012.30.28.png",
  engine:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_szerelomuhely/artifacts/ayfpzwvs_Ke%CC%81pernyo%CC%8Bfoto%CC%81%202026-09-03%20-%2012.23.53.png",
  lift:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_szerelomuhely/artifacts/zbmd5yi3_Ke%CC%81pernyo%CC%8Bfoto%CC%81%202026-09-03%20-%2012.23.31.png",
};

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1629093966234-c809247aa981?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  tire:
    "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  engine:
    "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  garage:
    "https://images.unsplash.com/photo-1632405862117-236585cfb757?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  wheel:
    "https://images.unsplash.com/photo-1593699199342-59b40e08f0ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    key: "gumiszerviz",
    title: "Gumiszerviz",
    icon: "CircleDot",
    image: IMAGES.tire,
    desc: "Szezonális gumicserétől a defekt javításig, minden egy helyen.",
    items: [
      "Gumicsere és -szerelés",
      "Kerék centrírozás (kiegyensúlyozás)",
      "Guminyomás ellenőrzés és javítás",
      "Defektjavítás, szelepcsere",
    ],
  },
  {
    key: "autoszerviz",
    title: "Általános autószerviz",
    icon: "Wrench",
    image: IMAGES.engine,
    desc: "Komplett szervizmunkák megbízható diagnosztikával.",
    items: [
      "Számítógépes hibakód-diagnosztika",
      "Alkatrészbeszerzés gyári minőségben",
      "Fék- és futóműjavítás",
      "Olaj- és szűrőcsere",
    ],
  },
];

// Service options for the booking select
export const SERVICE_OPTIONS = [
  "Gumicsere / szerelés",
  "Centrírozás (kiegyensúlyozás)",
  "Guminyomás ellenőrzés / javítás",
  "Defektjavítás",
  "Hibakód-diagnosztika",
  "Fék- és futóműjavítás",
  "Olajcsere",
  "Egyéb / általános szerviz",
];

export const REVIEWS = [
  {
    name: "Elégedett ügyfél",
    car: "Személyautó",
    rating: 5,
    text:
      "Abszolút korrekt szerviz. Hamar kaptam időpontot, a reggel leadott autóm délutánra elkészült. A munkáról részletes számlát kaptam – a végösszeg nem volt kevés, de lehúzásnak nyoma sem volt.",
  },
  {
    name: "Zoltán Pataki",
    car: "Guminyomás probléma",
    rating: 5,
    text:
      "Az autóm guminyomás problémáját nem tudtam megoldani. A szerelő azonnal vállalta, hogy megvizsgálja a problémát és kb. 5 perc alatt meg is oldotta.",
  },
  {
    name: "Lázár László",
    car: "Kerék nyomásvesztés",
    rating: 5,
    text:
      "Soron kívül fogadtak az egyik keréknél nyomásvesztés miatt. Gyors, precíz munkát végeztek, és elhárították a hibát. Ajánlott gumiszerviz.",
  },
];

// Time slots based on weekday. 0=Sun ... 6=Sat
export function getTimeSlots(date) {
  if (!date) return [];
  const dow = date.getDay();
  if (dow === 0 || dow === 6) return []; // weekend closed
  const end = dow === 5 ? "16:00" : "16:30";
  const slots = [];
  let h = 8;
  let m = 0;
  const [eh, em] = end.split(":").map(Number);
  while (h < eh || (h === eh && m <= em)) {
    slots.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
    m += 30;
    if (m >= 60) {
      m = 0;
      h += 1;
    }
  }
  return slots;
}

export function isClosedDay(date) {
  const dow = date.getDay();
  return dow === 0 || dow === 6;
}
